import { ExternalLink } from "lucide-react";

export default function Cases() {
  const cases = [
    {
      image: "/images/case-ecommerce.jpg",
      category: "E-COMMERCE",
      title: "Интернет-магазин премиум товаров",
      description: "Разработали современную e-commerce платформу с персонализацией и продвинутой аналитикой",
      technologies: ["React/Next.js", "Node.js/Nest.js", "PostgreSQL"],
      result: "+180% конверсий",
      gradient: "from-sprintwise-primary to-sprintwise-secondary"
    },
    {
      image: "/images/case-fitness.jpg",
      category: "MOBILE APP",
      title: "Мобильное приложение для фитнеса",
      description: "Создали кроссплатформенное приложение с трекингом активности и социальными функциями",
      technologies: ["React Native", "Firebase", "Redux"],
      result: "50K+ пользователей",
      gradient: "from-sprintwise-secondary to-sprintwise-accent"
    },
    {
      image: "/images/case-crm.jpg",
      category: "ENTERPRISE",
      title: "Корпоративная CRM система",
      description: "Разработали масштабируемую CRM с интеграциями и продвинутой аналитикой для крупной компании",
      technologies: ["Angular", "Go", "MongoDB"],
      result: "-60% время обработки",
      gradient: "from-sprintwise-primary to-sprintwise-secondary"
    }
  ];

  return (
    <section id="cases" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-sprintwise-dark mb-6" data-testid="cases-title">
            Наши <span className="gradient-text">кейсы</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="cases-description">
            Успешные проекты, которые помогли нашим клиентам достичь бизнес-целей
          </p>
        </div>
        
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">
          {cases.map((caseItem, index) => (
            <div key={index} className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300" data-testid={`case-card-${index}`}>
              <img 
                src={caseItem.image} 
                alt={caseItem.title} 
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300" 
                data-testid={`case-image-${index}`}
              />
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className={`bg-gradient-to-r ${caseItem.gradient} bg-clip-text text-transparent font-semibold text-sm`} data-testid={`case-category-${index}`}>
                    {caseItem.category}
                  </span>
                  <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-sprintwise-primary transition-colors" />
                </div>
                <h3 className="text-xl font-semibold text-sprintwise-dark mb-3" data-testid={`case-title-${index}`}>
                  {caseItem.title}
                </h3>
                <p className="text-gray-600 mb-4 text-sm" data-testid={`case-description-${index}`}>
                  {caseItem.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {caseItem.technologies.map((tech, techIndex) => (
                    <span 
                      key={techIndex} 
                      className={`text-xs px-2 py-1 rounded-full ${
                        techIndex === 0 ? 'bg-blue-100 text-blue-800' :
                        techIndex === 1 ? 'bg-green-100 text-green-800' :
                        'bg-purple-100 text-purple-800'
                      }`}
                      data-testid={`case-tech-${index}-${techIndex}`}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="text-2xl font-bold gradient-text" data-testid={`case-result-${index}`}>
                  {caseItem.result}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
